import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_REFRESH_WA_TEMPLATE_SERVER } from '@/app/module/content/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetWaTemplateRefresh = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [refresh, res] = esApi.endpoints.getOrgWaTemplatesRefresh.useMutation()

  const refreshTemplate = useCallback(
    async (id: number) => {
      try {
        await refresh({ orgId: orgId.toString(), id: id.toString(), body: {} }).unwrap()
        return true
      } catch (error) {
        dispatch(
          createNotification({
            'refresh-wa-template-failure': {
              type: 'error',
              message: getErrorMessage(error, ERROR_REFRESH_WA_TEMPLATE_SERVER),
            },
          }),
        )
        return false
      }
    },
    [orgId, dispatch, refresh],
  )

  return [refreshTemplate, res] as const
}
